import React, { useEffect, useState } from "react"
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import "leaflet/dist/leaflet.css";
import { AddImageServ, OrderImagesServ, ProcessAllImageServ, RedoServ, RemoveImageServ, ResetServ, UndoServ } from "../../Services/AIListingCreation";
import UndoImage from "../Comp-enhance-AIlisting/undo-image";
import RedoImage from "../Comp-enhance-AIlisting/redo-image";
import ResetImage from "../Comp-enhance-AIlisting/reset-image";
import OrderListings from "../Comp-enhance-AIlisting/order-listings";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ProcessMultiImageServ } from "../../Services/Enhance";
import AddImage from "../Comp-enhance-AIlisting/add-image";
import { PropertyDetailsObj } from "../../Models/PropertyDetailsObj";
import PropertyInfo from "./property-info";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchHeaderData } from "../store/headerSlice";
import { useAppDispatch } from "../store/store";
import Recommendation from "../Comp-enhance-AIlisting/recommendation/recommendation";
import BeforeAfterSlider from "../Comp-enhance-AIlisting/before-after-slider";
import AllEnhancement from "../Comp-enhance-AIlisting/enhancement/all-enhancement";
import ApplyAllImages from "../Comp-enhance-AIlisting/enhancement/apply-all-images";
import AdvancedGeneration from "../Comp-enhance-AIlisting/generation/advanced-generation";
import { PropertyObj } from "../../Models/PropertyObj";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;

const EditListing: React.FunctionComponent<{ property: PropertyDetailsObj, onUpdateProperty: any }> = (props) => {

    const [open, setOpen] = useState(false);
    const [activeTab, setActiveTab] = useState<string>("Recommendation");
    const [listingValue, setListingValue] = useState<PropertyObj>(() => {
        if (props.property.content) {
            return mapToPropertyObj(props.property);
        }
        return {} as PropertyObj;
    });
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageSelected, setImageSelected] = useState<any[]>([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const [idProperty, setIdProperty] = useState<any>(props.property.id || "");
    let location: any = useLocation().pathname.split('/');
    const [processingImages, setProcessingImages] = useState<Array<string | number>>([]);
    const [isApplyingMap, setIsApplyingMap] = useState<Record<string, boolean>>({});
    const [processingIds, setProcessingIds] = useState<Array<string | number>>([]);
    const [isApplying, setIsApplying] = useState<boolean>(false);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [processedImages, setProcessedImages] = useState<any[]>([]);
    const [clearSelection, setClearSelection] = useState<boolean>(false);
    const [propertyValue, setPropertyValue] = useState<any>();

    useEffect(() => {
        if (listingValue.images && listingValue.images[currentImageIndex]) {
            if (imageSelected.length === 0) {
                setImageSelected([listingValue.images[currentImageIndex]]);
            }
        }
    }, [currentImageIndex, listingValue, imageSelected]);

    // Synchronize local state with props.property when it changes (after save/update)
    useEffect(() => {
        if (props.property.content) {
            setListingValue(mapToPropertyObj(props.property));
        }
    }, [props.property]);

    useEffect(() => {
        setProcessingImages(processingImages);
    }, [processingImages]);

    function mapToPropertyObj(raw: any): PropertyObj {
        return {
            _id: raw._id,
            referenceNumber: raw.content.referenceNumber,
            propertyType: raw.content.propertyType,
            address: raw.content.address,
            lang: raw.content.languages,
            descriptionTitle: raw.content.descriptionTitle,
            other_desc: raw.content.other_desc,
            description: raw.content.description,
            title: raw.content.title,
            images: raw.content.images,
            offeringType: raw.content.offeringType,
            price: raw.content.price,
            completionStatus: raw.content.completionStatus,
            bedroom: Number(raw.content.bedroom),
            bathroom: Number(raw.content.bathroom),
            buildYear: raw.content.buildYear,
            furnishingType: raw.content.furnishingType,
            size: raw.content.size
                ? {
                    builtUpSize: raw.content.size.builtUp,
                    unitBuiltUp: raw.content.size.unit,
                    plotSize: raw.content.size.plotSize,
                    unitPlot: raw.content.size.unitPlot,
                }
                : undefined,
            view360: raw.content.view360,
            videoTourUrl: raw.content.videoTourUrl,
            floor: raw.content.floor,
            rooms: raw.content.rooms,
            EPD: raw.content.EPD,
            GHG: raw.content.GHG,
            energySources: raw.content.energySources,
            heatingType: raw.content.heatingType,
            Permit: raw.content.Permit,
            agent: {
                _id: raw.content.agent?.id,
                fullName: raw.content.agent?.name,
                image: raw.content.agent?.photo,
                phoneNumber: raw.content.agent?.phoneNumbers,
                email: raw.content.agent?.emailAddresses,
                languages: raw.content.agent?.langs,
            },
            idProperty: raw.id,
            company: {
                name: raw.content.company?.name,
                logo: raw.content.company?.logo
            },
            category: raw.content.category ? raw.content.category : "residential",
            parking: raw.content.parking,
            availableForm: raw.content.availableForm,
            deliveryDate: raw.content.deliveryDate,
            paymentCheques: raw.content.paymentCheques,
            QrCode: raw.content.QrCode,
            privateAmenities: typeof raw.content.private_amenities === "string"
                ? raw.content.private_amenities.split(",").map((item: string) => item.trim())
                : raw.content.private_amenities,
            sharedAmenities: typeof raw.content.shared_amenities === "string"
                ? raw.content.shared_amenities.split(",").map((item: string) => item.trim())
                : raw.content.shared_amenities,
            serviceCharge: raw.content.serviceCharge,
            titleDeed: raw.content.titleDeed,
            paymentMethod: raw.content.paymentMethod,
            downPayment: raw.content.downPayment,
            mortgageAvailable: raw.content.mortgageAvailable,
            yearsofmortgage: raw.content.mortgageYears,
            rentalPeriod: raw.content.rentalPeriod,
            numberOfCheques: raw.content.numberOfCheques
        };
    }

    const EnhancedImageHandler = async (images: any[], url: string, data: any) => {
        setIsApplying(true);
        setProcessedImages([]);

        // Clear all selected images at the start to allow user to select a new group for other enhancements
        setImageSelected([]);
        setClearSelection(true);

        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);

        // Track which images are currently being processed for precise spinner control
        const keys = images.map((img) => `${img.id}:${url}`);
        setProcessingImages((prev) => [...prev, ...keys]);
        setProcessingIds((prev) => [...prev, ...images.map((img) => img.id)]);
        setIsApplyingMap((prev) => {
            const updated = { ...prev };
            images.forEach((img) => {
                updated[img.id] = true;
            });
            return updated;
        });
        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            try {
                const obj = {
                    processid: props.property.processId,
                    images: [image],
                    url: url,
                    data: data,
                };
                const resp = await ProcessMultiImageServ(obj);
                setListingValue((prevOptions: any) => ({
                    ...prevOptions,
                    images: resp?.images,
                }));
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("Image Enhanced Successfully !");
                dispatch(fetchHeaderData());
            } catch (error: any) {
                if (error.response?.status === 401) {
                    setMessage(error.response.data.message);
                } else {
                    setColorSnackbar("error");
                    setOpenSnackbar(true);
                    setMessage("Failed to enhance image. Please try again.");
                }
            } finally {
                setIsApplying(false);
                setProcessingIds((prev) => prev.filter((id) => id !== image.id));
                setProcessingImages((prev) => prev.filter((id: any) => id !== `${image.id}:${url}`));
                setIsApplyingMap((prev) => {
                    const updated = { ...prev };
                    updated[image.id] = false;
                    return updated;
                });
            }
        }
    };

    const GeneratedImageHandler = async (images: any[], url: string, data: any) => {
        setIsApplying(true);
        setProcessedImages([]);
        setImageSelected([]);
        setClearSelection(true);

        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);

        const keys = images.map((img) => `${img.id}:${url}`);
        setProcessingImages((prev) => [...prev, ...keys]);
        setProcessingIds((prev) => [...prev, ...images.map((img) => img.id)]);
        setIsApplyingMap((prev) => {
            const updated = { ...prev };
            images.forEach((img) => {
                updated[img.id] = true;
            });
            return updated;
        });
        if (Array.isArray(images)) {
            for (let i = 0; i < images.length; i++) {
                const img = images[i];
                try {
                    const obj = {
                        processid: props.property.processId,
                        images: [img],
                        url: url,
                        data: data
                    };
                    const resp = await ProcessMultiImageServ(obj);
                    setListingValue((prevOptions: any) => ({
                        ...prevOptions,
                        images: resp?.images,
                    }));
                    setColorSnackbar("success");
                    setOpenSnackbar(true);
                    setMessage("Image Generated Successfully !");
                    setTimeout(() => {
                        dispatch(fetchHeaderData());
                    }, 2000)
                } catch (error: any) {
                    if (error.response.status === 401) {
                        setMessage(error.response.data.message);
                    } else {
                        setColorSnackbar("error");
                        setOpenSnackbar(true);
                        setMessage("Failed to generate image. Please try again.");
                    }
                } finally {
                    setIsApplying(false);
                    setProcessingIds((prev) => prev.filter((id) => id !== img.id));
                    setProcessingImages((prev) => prev.filter((id: any) => id !== `${img.id}:${url}`));
                    setIsApplyingMap((prev) => {
                        const updated = { ...prev };
                        updated[img.id] = false;
                        return updated;
                    });
                }
            }
        }
    }

    const AddImagesHandler = (obj: any) => {
        return new Promise((resolve, reject) => {
            AddImageServ(props.property.processId, obj).then((resp) => {
                setListingValue((prevOptions: any) => ({
                    ...prevOptions,
                    images: resp?.images,
                }))
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("Images Uploaded Successfully !");
                resolve(resp);
            }).catch((error) => {
                setColorSnackbar("error");
                setOpenSnackbar(true);
                setMessage(error.response.data.message);
                reject(error);
            })
        });
    }

    const UndoImageHandler = (value: any) => {

        return new Promise((resolve, reject) => {
            UndoServ({ processid: props.property.processId, imageid: value }).then((resp) => {
                setListingValue((prevOptions: any) => ({
                    ...prevOptions,
                    images: resp?.images,
                }));
                resolve(resp)

            }).catch((error) => {
                setColorSnackbar("error");
                setOpenSnackbar(true);
                setMessage(error.response.data.message);
                reject(error);

            })
        });
    }

    const ResetImageHandler = () => {
        return new Promise((resolve, reject) => {
            const imagesToReset = [...imageSelected];
            if (imagesToReset.length === 0) {
                resolve("");
                return;
            }
            setIsApplying(true);
            setProcessedImages([]);
            setImageSelected([]);
            setProcessingIds((prev) => [...prev, ...imagesToReset.map((img) => img.id)]);
            setIsApplyingMap((prev) => {
                const updated = { ...prev };
                imagesToReset.forEach((img) => {
                    updated[img.id] = true;
                });
                return updated;
            });
            const promises = imagesToReset.map((image) => {
                return ResetServ({
                    processid: props.property.processId,
                    imageid: image.id,
                })
                    .then((resp) => {
                        setListingValue((prevOptions: any) => ({

                            ...prevOptions,
                            images: resp?.images,

                        }));
                    })
                    .catch((error) => {
                        setColorSnackbar("error");
                        setOpenSnackbar(true);
                        setMessage(error.response.data.message);
                    })
                    .finally(() => {
                        setProcessingIds((prev) =>
                            prev.filter((id) => id !== image.id)
                        );
                        setIsApplyingMap((prev) => {
                            const updated = { ...prev };
                            updated[image.id] = false;
                            return updated;
                        });
                    });
            });
            Promise.allSettled(promises)
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => {
                    setIsApplying(false);
                });
        });
    };

    const RedoImageHandler = (value: any) => {
        return new Promise((resolve, reject) => {
            RedoServ({ processid: props.property.processId, imageid: value }).then((resp) => {
                setListingValue((prevOptions: any) => ({

                    ...prevOptions,
                    images: resp?.images,
                }));
                resolve(resp)

            }).catch((error) => {
                setColorSnackbar("error");
                setOpenSnackbar(true);
                setMessage(error.response.data.message);
                reject(error);
            })
        });
    };

    const handleDelete = (id: any) => {

        return new Promise((resolve, reject) => {
            const obj = {
                processid: props.property.processId,
                imageid: id
            }
            RemoveImageServ(obj).then((resp) => {
                setListingValue((prevOptions: any) => ({

                    ...prevOptions,
                    images: resp?.images,

                }))
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("Image Deleted Successfully!");
                setCurrentImageIndex(0);
                resolve(resp);
            }).catch((error) => {
                setColorSnackbar("error");
                setOpenSnackbar(true);
                setMessage(error.response.data.message);
                reject(error);

            })
        });
    };

    const ApplyAllImagesHandler = async (url: string, data: any) => {
        setIsApplying(true);
        setImageSelected([]);
        setClearSelection(true);
        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);
        const allImages: any[] = (listingValue && Array.isArray(listingValue.images)) ? listingValue.images : [];
        const images = allImages.filter((img) => {
            return !img.doneEnhancments?.includes("Image Super Resolution");
        });
        const keys = images.map((img) => `${img.id}:${url}`);
        setProcessingImages((prev) => [...prev, ...keys]);
        setProcessingIds((prev) => [...prev, ...images.map((img) => img.id)]);
        setIsApplyingMap((prev) => {
            const updated = { ...prev };
            images.forEach((img) => {
                updated[img.id] = true;
            });
            return updated;
        });
        if (url === "Add Watermark") {
            try {
                for (let i = 0; i < images.length; i++) {
                    const img = images[i];
                    try {
                        const obj = {
                            processid: props.property.processId,
                            images: [img],
                            url: url,
                            data: data
                        };
                        const resp = await ProcessMultiImageServ(obj);
                        setListingValue((prevOptions: any) => ({
                            ...prevOptions,
                            images: resp?.images,

                        }))
                        setColorSnackbar("success");
                        setOpenSnackbar(true);
                        setMessage("Image Enhanced Successfully !");
                        setTimeout(() => {
                            dispatch(fetchHeaderData());
                        }, 2000);
                    } catch (error: any) {
                        setColorSnackbar("error");
                        setOpenSnackbar(true);
                        if (error?.response?.status === 401) {
                            setMessage(error.response.data.message);
                        } else {
                            setMessage( "Failed to enhance image. Please try again.");
                        }
                    } finally {
                        setProcessingIds((prev) =>
                            prev.filter((id) => id !== img.id)
                        );
                        setProcessingImages((prev) =>
                            prev.filter((id: any) => id !== `${img.id}:${url}`)
                        );
                        setIsApplyingMap((prev) => {
                            const updated = { ...prev };
                            updated[img.id] = false;
                            return updated;
                        });
                    }
                }
            } finally {
                setIsApplying(false);
            }
        }
        else {
            try {
                const obj = {
                    processid: props.property.processId,
                    url: url,
                    data: data
                };
                const resp = await ProcessAllImageServ(obj);
                setListingValue((prevOptions: any) => ({
                    ...prevOptions,
                    images: resp?.images,
                }))
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("Images Enhanced Successfully !");
                setTimeout(() => {
                    dispatch(fetchHeaderData());
                }, 2000)
            } catch (error: any) {
                setColorSnackbar("error");
                setOpenSnackbar(true);
                if (error?.response?.status === 401) {
                    setMessage(error.response.data.message);
                } else {
                    setMessage(error.response.data.message ? error.response.data.message : "Failed to enhance image. Please try again.");
                }
            } finally {
                setIsApplying(false);
                setProcessingIds([]);
                setProcessingImages([]);
                setIsApplyingMap({})
            }
        }
    };

    const SaveOrderHandler = (images: any) => {
        return new Promise((resolve, reject) => {
            const obj = {
                processid: props.property.processId,
                images: images
            };
            OrderImagesServ(obj).then((resp) => {
                setListingValue((prevOptions: any) => ({
                    ...prevOptions,
                    images: resp?.images,

                }))
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("The order of images has been successfully updated !");
                resolve(resp);
            }).catch((error) => {
                setColorSnackbar("error");
                setOpenSnackbar(true);
                setMessage(error.response.data.message);
                reject(error);
            })
        });
    };

    const UpdateProperty = () => {
        const updatedContent = {
            address: propertyValue.address,
            idProperty: propertyValue.idProperty,
            propertyType: propertyValue.propertyType,
            languages: propertyValue.lang,
            descriptionTitle: propertyValue.descriptionTitle,
            other_desc: propertyValue.other_desc,
            description: propertyValue.description,
            title: propertyValue.title,
            private_amenities: typeof propertyValue.privateAmenities === "string"
                ? propertyValue.privateAmenities.split(",").map((item: string) => item.trim())
                : propertyValue.privateAmenities,
            shared_amenities: typeof propertyValue.sharedAmenities === "string"
                ? propertyValue.sharedAmenities.split(",").map((item: string) => item.trim())
                : propertyValue.sharedAmenities,
            images: listingValue.images,
            offeringType: propertyValue.offeringType,
            category: propertyValue.category,
            parking: propertyValue.parking,
            availableForm: propertyValue.availableForm,
            deliveryDate: propertyValue.deliveryDate,
            paymentCheques: propertyValue.paymentCheques,
            paymentMethod: propertyValue.paymentMethod,
            downPayment: propertyValue.downPayment,
            mortgageAvailable: propertyValue.mortgageAvailable,
            yearsofmortgage: propertyValue.yearsofmortgage,
            rentalPeriod: propertyValue.rentalPeriod,
            numberOfCheques: propertyValue.numberOfCheques,
            view: propertyValue.view,
            rooms: propertyValue.rooms,
            EPD: propertyValue.EPD,
            GHG: propertyValue.GHG,
            energySources: propertyValue.energySources,
            heatingType: propertyValue.heatingType,
            Permit: propertyValue.Permit,
            price: propertyValue.price,
            completionStatus: propertyValue.completionStatus,
            bedroom: (propertyValue.bedroom ?? "").toString(),
            bathroom: (propertyValue.bathroom ?? "").toString(),
            floor: propertyValue.floor,
            buildYear: propertyValue.buildYear,
            furnishingType: propertyValue.furnishingType,
            size: {
                builtUp: propertyValue.size?.builtUpSize,
                plotSize: propertyValue.size?.plotSize,
                unit: propertyValue.size?.unitBuiltUp,
                unitPlot: propertyValue.size?.unitPlot,
            },
            view360: propertyValue.view360,
            titleDeed: propertyValue.titleDeed,
            videoTourUrl: propertyValue.videoTourUrl,
            agent: {
                id: propertyValue.agent?._id,
                name: propertyValue.agent?.fullName,
                photo: {
                    src: propertyValue.agent?.image?.src
                },
                langs: propertyValue.agent?.languages,
                phoneNumbers: propertyValue.agent?.phoneNumber,
                emailAddresses: propertyValue.agent?.email,
            },
            company: {
                name: propertyValue.company?.name,
                logo: {
                    src: propertyValue.company?.logo?.src
                },
            },
        };
        props.onUpdateProperty(updatedContent, props.property._id);
        setOpen(false);
    };

    const UpdateListingHandler = (value: any) => {
        setPropertyValue((prevOptions: any) => ({
            ...prevOptions,
            ...value
        }))
    };

    const edit = () => {
        setOpen(true);
    }

    const AnalysisCompleteHandler = (data: any, isError: boolean, msg: string) => {

        if (!isError) {
            setListingValue((prevOptions: any) => {
                return {
                    ...prevOptions,
                    images: prevOptions.images.map((img: any) => {
                        if (img.id === data.imageId || img.id === data.image?.id) {
                            return {
                                ...img,
                                ...data.image,
                                toAnalyze: true,
                                originalImage: img.originalImage,
                            };
                        }
                        return img;
                    }),
                };
            });
            ChangeMessageHandler("Image analysis completed successfully!", true, "success")

        } else {
            ChangeMessageHandler(msg, isError, "error")
        }
    };

    const ChangeMessageHandler = (msg: string, value: boolean, color: string) => {
        setColorSnackbar(color)
        setOpenSnackbar(true)
        setMessage(msg)
    }

    const handleSelectedImages = (images: any[], index: any) => {
        setCurrentImageIndex(index);
        if (images.length > 0) {
            // filter: keep only images that still match sessionStorage state
            let validImages = images;
            if (listingValue) {
                validImages = images.filter((img: any) => {
                    const fresh = listingValue?.images?.find((f: any) => f.id === img.id);
                    return fresh && fresh.src === img.src; // only keep if not updated yet
                });
            }

            setImageSelected(validImages);
        } else {
            if (listingValue.images && listingValue.images[index]) {
                setImageSelected([listingValue.images[index]]);
            } else {
                setImageSelected([]);
            }
        }
    };

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    }

    return (
        <>
            {location.length == 2 && location[1] === "properties" ?
                <button type="button" className="btn p-0  hide-arrow" onClick={edit} >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_168_178)">
                            <path d="M5.83398 5.83334H5.00065C4.55862 5.83334 4.1347 6.00894 3.82214 6.3215C3.50958 6.63406 3.33398 7.05798 3.33398 7.50001V15C3.33398 15.442 3.50958 15.866 3.82214 16.1785C4.1347 16.4911 4.55862 16.6667 5.00065 16.6667H12.5007C12.9427 16.6667 13.3666 16.4911 13.6792 16.1785C13.9917 15.866 14.1673 15.442 14.1673 15V14.1667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16.9875 5.4875C17.3157 5.15929 17.5001 4.71415 17.5001 4.25C17.5001 3.78585 17.3157 3.3407 16.9875 3.0125C16.6593 2.68429 16.2142 2.49991 15.75 2.49991C15.2858 2.49991 14.8407 2.68429 14.5125 3.0125L7.5 10V12.5H10L16.9875 5.4875Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M13.334 4.16666L15.834 6.66666" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_168_178">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </button> : <button className="back-trans border-trans color-4F52C1 button-reset " onClick={edit} >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_830_3870)">
                            <path d="M7 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M7 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20.385 6.58499C20.7788 6.19114 21.0001 5.65697 21.0001 5.09999C21.0001 4.543 20.7788 4.00883 20.385 3.61499C19.9912 3.22114 19.457 2.99988 18.9 2.99988C18.343 2.99988 17.8088 3.22114 17.415 3.61499L9 12V15H12L20.385 6.58499Z" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20.385 6.58499C20.7788 6.19114 21.0001 5.65697 21.0001 5.09999C21.0001 4.543 20.7788 4.00883 20.385 3.61499C19.9912 3.22114 19.457 2.99988 18.9 2.99988C18.343 2.99988 17.8088 3.22114 17.415 3.61499L9 12V15H12L20.385 6.58499Z" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16 5L19 8" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16 5L19 8" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_830_3870">
                                <rect width="24" height="24" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    {t("listingCreation.editListings")}
                </button>
            }

            <Dialog
                fullWidth
                maxWidth="xl"
                open={open}
                onClose={() => setOpen(false)}
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle id="customized-dialog-title">
                    <div className="title-20 bold-700 padd-10">{t("listingCreation.editListings")}</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[800],
                        '&:hover': { backgroundColor: theme.palette.grey[400] }
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="padd-0-20">
                        {listingValue?.images && <div className="row">
                            <div className="col-md-4 order-22  scroll-container max-height-65">
                                <div className="enhancement-tabs-container mb-4" >
                                    <div className="d-flex justify-content-between gap-20 align-items-center mb-4">
                                        <h3 className="title-20 color-black text-nowrap">
                                            {t("enhancementList.title")}</h3>
                                    </div>
                                    <div className="tabs mb-4 width-tabs">
                                        <button
                                            className={`tab para-14 width-100-100 color-black bold-500 ${activeTab === "Recommendation" ? "active" : ""}`}
                                            onClick={() => setActiveTab("Recommendation")} >
                                            {t("enhancementList.recommendation")}
                                        </button>
                                        <button
                                            className={`tab para-14 color-black width-100-100 bold-500 ${activeTab === "AllEnhancement" ? "active" : ""}`}
                                            onClick={() => setActiveTab("AllEnhancement")}
                                        >
                                            {t("enhancementList.allEnhancement")}
                                        </button>
                                    </div>

                                    {activeTab == "Recommendation" ? <ul className="p-0 m-0 list-style-none mb-4">
                                        <Recommendation recommendationsValue={imageSelected} processId={props.property.processId || ""} onAnalysisComplete={AnalysisCompleteHandler} onEnhancedImage={EnhancedImageHandler} processingIds={processingImages} isApplyingMap={isApplyingMap} currentImageIndex={currentImageIndex} listing={listingValue} />
                                    </ul> :
                                        <ul className="p-0 m-0 list-style-none mb-4">
                                            <AllEnhancement imageValue={imageSelected} onEnhancedImage={EnhancedImageHandler} processingIds={processingImages} isApplyingMap={isApplyingMap} currentImageIndex={currentImageIndex} listing={listingValue} />
                                        </ul>
                                    }
                                </div>
                                <AdvancedGeneration imageValue={imageSelected} onEnhancedImage={GeneratedImageHandler} onChangeMessagehandler={ChangeMessageHandler} processingIds={processingImages} isApplyingMap={isApplyingMap} currentImageIndex={currentImageIndex} listing={listingValue} />
                            </div>
                            <div className="col-md-8">
                                <div className="card border-20 mb-4" >
                                    <div className="card-body  padd-24">
                                        <div className="row d-flex justify-content-between align-items-center">
                                            <div className="col-1 mb-4">
                                                <UndoImage imageValue={listingValue.images && listingValue.images[currentImageIndex] ? listingValue.images[currentImageIndex] : null} onUndoImage={UndoImageHandler} />

                                                <RedoImage imageValue={listingValue.images && listingValue.images[currentImageIndex] ? listingValue.images[currentImageIndex] : null} onRedoImage={RedoImageHandler} />

                                            </div>

                                            <div className="col-2 mb-4 d-flex justify-content-end">

                                                <ResetImage imageValue={listingValue.images && listingValue.images[currentImageIndex] ? listingValue.images[currentImageIndex] : null} onResetImage={ResetImageHandler} />

                                                <AddImage onAddImages={AddImagesHandler} />

                                            </div>
                                        </div>

                                        <BeforeAfterSlider images={listingValue.images} onDelete={handleDelete} onSelectedImages={handleSelectedImages} applaying={isApplying} processedImages={processedImages} setapplying={setIsApplying} processingIds={processingIds} clearSelection={clearSelection} />

                                        <div className="row d-flex justify-content-between align-items-center  mb-4  mt-4">
                                            <div className="col-1">
                                                <h3 className="title-20 color-black ">
                                                    {t("enhancementList.applyToAllImages")}
                                                </h3>
                                            </div>
                                            <div className="col-2 d-flex justify-content-end">
                                                <OrderListings listingValue={listingValue?.images} onSaveOrder={SaveOrderHandler} />
                                            </div>
                                        </div>
                                        <div className="row d-flex justify-content-center ">
                                            <ApplyAllImages onApplyAllImages={ApplyAllImagesHandler} onChangeMessagehandler={ChangeMessageHandler} processingIds={processingImages} />
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-20 mb-4" >
                                    <PropertyInfo property={listingValue} id={idProperty} processId={props.property.processId} onChangehandler={ChangeMessageHandler} onUpdateListing={UpdateListingHandler} />
                                </div>
                            </div>
                        </div>}
                        <div className="d-flex justify-content-end">
                            <button className="button-dash back-EEF2FF  color-4F52C1 border-4F52C1 border-6 padd-15-40 width-auto bold-700 " onClick={UpdateProperty}>
                                {t("propertiesPage.save")}</button>
                        </div>
                    </div>
                </DialogContent>

            </Dialog>


            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={20000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

        </>
    )
}
export default EditListing;